export const isModifiedEvent = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
